module.exports = __webpack_public_path__ + "75b672ea4fdf9733c36c86a8a9f3bd4c.svg";